<template>
  <md-toolbar
    id="topbar"
    v-resize="onResize"
    md-elevation="0"
    class="md-transparent"
    style="z-index:1"
  >
    <div class="md-toolbar-row" >
      <div class="md-toolbar-section-start" style="margin-left: -10px;">
        <img v-if="isMobile" :src="imgLogo" class="logomobile" alt="logo" style="height: 40px;" />

        <h4 
          style="color: #fff!important;font-size: 18px;margin:8px; padding:0; font-weight: 500;margin-left: 35%;display: flex;white-space: nowrap;"
        >{{$route.name}}</h4>
      </div>
      <div class="md-toolbar-section-end">
        <div style="position: relative;
  z-index: 1;" >
          <md-button  @click.native="toggleSidebar"
            class="md-just-icon md-simple md-toolbar-toggle"
            style="z-index: 500"
          >
            <md-icon  style="color: #fff!important;">menu</md-icon>
          </md-button>
        </div>
        <div class="md-collapse">
          <!-- <div class="md-autocomplete">
            <md-autocomplete class="search" v-model="selectedEmployee" :md-options="employees">
              <label>Pesquisar...</label>
            </md-autocomplete>
          </div>-->
          <md-list>
            <md-list-item href="/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>
            <md-list-item href="/companies">
              <font-awesome-icon icon="building" style="font-size:16px!important" />
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
            <md-list-item href="/disp">
              <i class="material-icons" style="font-size:23px!important">people</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>

            <!-- <md-list-item href="/config">
              <i class="material-icons" style="font-size:20px!important">settings</i>
              <p class="hidden-lg hidden-md">Configurações</p>
            </md-list-item>-->
            <md-list-item href="/login">
              <i class="material-icons" style="font-size:20px!important">exit_to_app</i>
              <p class="hidden-lg hidden-md">Sair</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
      selectedEmployee: null,
      employees: ["Recurso Indisponível"]
    };
  },
  props: {
    imgLogo: {
      type: String,
      default: require("@/assets/img/logorealtec-w.svg")
    },
    recIcon: {
      type: String,
      default: require("@/assets/img/rec-icon.svg")
    }
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toggleSidebar() {
      document.getElementById("wrapper").classList.add("nav-open");
    }
  },
  created() {
    if (window.innerWidth < 769) this.isMobile = true;
    else {
      this.isMobile = false;
    }
  }
};
</script>


<style lang="scss" scoped>
.md-list-item .md-list-item-container {
  color: rgba(54, 54, 54, 0.45) !important;
  background: transparent !important;
}
.md-app {
  max-height: 400px;
  border: 1px solid rgba(#000, 0.12);
}

// Demo purposes only
.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}

.md-toolbar.md-elevation-0 {
  border-radius: 0;
  position: fixed;
  width: inherit;
  box-shadow: 5px -1px 6px 0px #00000052;
  background: #eaeaea !important;
}
.md-list-item.md-list-item-container.md-ripple {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.thid {
  display: none !important;
  opacity: 0 !important;
}
</style>
